// import { Container, Row, Col } from "react-bootstrap";

// function Contact() {
//     return (
//         <Container fluid className="education-section">
//             <Container>
//                 <div className="education-heading">
//                     <h1>Contact Me</h1>
//                     <p>You can reach me at:</p>
//                     <ul>
//                         <li>Email: davidmilsky@gmail.com </li>
//                     </ul>
//                 </div>
//             </Container>
//         </Container>
//     );
// }


import { Container, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useState } from "react";

function Contact() {
  const email = "davidmilsky@gmail.com";
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(email);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Container fluid className="education-section contact-section">
      <Container>
        <div className="education-heading">
          <h1>Contact Me</h1>
          <p>You can reach me at:</p>

          <div className="contact-row">
            <span className="contact-label">Email:</span>

            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip id="copy-tooltip">
                  {copied ? "Copied!" : "Click to copy"}
                </Tooltip>
              }
            >
              <button
                type="button"
                className={`copy-chip ${copied ? "copied" : ""}`}
                onClick={handleCopy}
                aria-label="Copy email to clipboard"
              >
                <span className="copy-text">{email}</span>
              </button>
            </OverlayTrigger>
          </div>
        </div>
      </Container>
    </Container>
  );
}

export default Contact;

